import { Action } from 'redux-actions';
import { all, put, select, takeEvery } from 'redux-saga/effects';

import { logCritical } from '@savgroup-front-common/configuration/appInsights/AppInsights';

import { getAuthorizedSellersRequest } from '../../api/Seller/getAuthorizedSellersQuery';
import { executeSagaRequest } from '../../services';
import { Selectors as requestSelectors } from '../sagaRequestMetadata';

import * as types from './actionTypes';

function* getSellerWorker({
  payload: { forceRefresh = false },
}: {
  payload: { forceRefresh?: boolean };
}): Generator {
  const wasLoaded = yield select((state) =>
    requestSelectors.wasActionLoadedSelector(state, types.GET_SELLER),
  );

  if (!wasLoaded || forceRefresh) {
    yield executeSagaRequest(
      types.GET_SELLER,
      getAuthorizedSellersRequest(),
      {},
    );
  }

  yield put(types.GET_SELLER.end());
}
function* getSellerWatcher() {
  yield takeEvery<Action<{ forceRefresh: boolean }>>(
    types.GET_SELLER.BASE,
    getSellerWorker,
  );
}

export default function* sellerSaga(): Generator {
  try {
    yield all([getSellerWatcher()]);
  } catch (error) {
    logCritical(error as any);
  }
}
